import * as api from "../../../api/index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  ALERT,
  COUNTER,
  REMOVE_PENDING_QUOTE,
  REMOVE_COMPLETED_QUOTES,
} from "../../../constants/actionTypes";

import dayjs from "dayjs";

import {
  ArrowForward,
  CancelOutlined,
  KeyboardArrowLeft,
  LibraryAddOutlined,
} from "@material-ui/icons";

import { VAT } from "../../../constants/actionTypes";
import Prices from "../../../utils/prices";

import "./Verify.css";

const Verify = ({
  showVerify,
  setShowVerify,
  quote,
  quotesLength,
  completed,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const counter = useSelector((state) => state.counter);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [approving, setApproving] = useState(false);
  const [declining, setDeclining] = useState(false);
  const [message, setMessage] = useState("");
  const [docLarge, setDocLarge] = useState(false);
  const [files, setFiles] = useState([]);
  const [stampedFiles, setStampedFiles] = useState([]);
  const [size, setSize] = useState([]);
  const [translations, setTranslations] = useState([]);
  const [translation, setTranslation] = useState({});
  const [title, setTitle] = useState();
  const [src, setSrc] = useState();
  const [type, setType] = useState();
  const [price, setPrice] = useState(0);

  const totalPages =
    !completed &&
    files.map((file) => file.page).reduce((acc, curr) => acc + curr, 0);

  const totals = Prices(
    price,
    totalPages,
    quote.languageTo.length,
    quote.urgent,
    quote.addson,
    24
  );

  const disableSend =
    isNaN(totalPages) || totalPages < 1 || price === 0 || sending;

  const languageTo = completed
    ? translations.map((translation) => translation.language)
    : quote.languageTo.map((lang) => lang);

  const translators = loading
    ? []
    : translations.map((translation) => translation.translator.name);

  const disable = loading || approving || declining;

  const notStamped =
    stampedFiles < 1 ||
    (translation && translation.files.length !== stampedFiles.length) ||
    size > 12000000;

  const checkPrice = (category) => {
    const catLowercase = category.toLowerCase();
    let price;
    if (catLowercase === "premium") price = 9.99;
    if (catLowercase === "advance") price = 4.99;
    if (catLowercase === "standard") price = 0.99;

    return price;
  };

  const handlePageChange = (value, index) => {
    setFiles(
      files.map((file, i) => {
        if (i === index) file.page = value;
        return file;
      })
    );
  };

  const openModal = (type, translation) => {
    if (completed) setTranslation(translation);
    setType(type);
    document.querySelector(".verify__details").style.zIndex = 4;
    document.querySelector(".verify__details").open = true;
  };

  const closeModal = () => {
    setType("");
    document.querySelector(".verify__details").style.zIndex = -1;
    document.querySelector(".verify__details").open = false;
  };

  const handlePreviewClick = (index, i) => {
    if (completed) {
      setTitle(translations[index].files[i].name);
      setSrc(translations[index].files[i].base64);
    } else {
      setTitle(files[index].name);
      setSrc(files[index].base64);
    }
  };
  const handleSend = async () => {
    setSending(true);
    const payment = {
      amount: totals.total * 100,
      category: quote.category,
      pages: totalPages,
      project: quote.projectName,
    };

    const invoice = {
      items: files.map((file) => {
        return {
          item: file.name,
          description: quote.projectName,
          quantity: file.page,
          unitCost: quote.urgent ? price + 24 : price,
        };
      }),
      type: "page",
      subtotal: totals.subtotal * 100,
      total: totals.total * 100,
      vatValue: totals.vat * 100,
      VAT: VAT,
      paid: 0,
      invoice_nr: quote.quote_id,
      addson: quote.addson,
      langs: quote.languageTo.length,
    };

    try {
      await api.updateQuote(quote.id, {
        status: "inactive",
        totalPages,
        payment,
        price,
        files,
      });
      await api.issueInvoice({
        email: null,
        user_id: quote.creator,
        invoice,
        id: quote.id,
        paid: 0,
        quote_email: quote.email,
        projectName: quote.projectName,
      });
      await api.counter({ pending_projects: -1 });
      dispatch({
        type: COUNTER,
        payload: { ...counter, pending_projects: counter.pending_projects - 1 },
      });
      if (quotesLength < 2) history.push("/admin/index");
      if (quotesLength > 1) setShowVerify(false);
      dispatch({ type: REMOVE_PENDING_QUOTE, id: quote.id });
      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Invoice sent",
          duration: 5000,
          display: true,
        },
      });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    }
  };

  const handleApprove = async () => {
    setApproving(true);
    const approved = { ...translation, files: stampedFiles };

    try {
      await api.updateUser(translation.translator.id, {
        $pull: {
          "workPlace.reveiwing": quote.id,
          "workPlace.ongoing_projects": quote.id,
          "workPlace.declined_projects": quote.id,
          "workPlace.decline_msg": { quote: { $in: [quote.id] } },
        },
      });
      await api.updateQuote(quote.id, {
        $push: { approved: approved },
        $pull: { translations: translation },
        $inc: { "tracker.translation": -1, "tracker.approved": 1 },
        "allocation.declined_msg": [],
      });
      await api.counter({ completed_projects: -1 });
      if (
        quote.languageTo.length - 1 === quote.tracker.approved ||
        quote.languageTo.length === 1
      ) {
        await api.updateQuote(quote.id, { status: "completed" });
        await api.counter({ ongoing_projects: -1, verified_projects: 1 });
        dispatch({
          type: COUNTER,
          payload: {
            ...counter,
            ongoing_projects: counter.ongoing_projects--,
            verified_projects: counter.verified_projects++,
          },
        });
      }
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          completed_projects: counter.completed_projects - 1,
        },
      });
      dispatch({ type: REMOVE_COMPLETED_QUOTES, id: quote.id });
      if (quotesLength < 2) history.push("/admin/index");
      if (quotesLength > 1) setShowVerify(false);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setApproving(false);
    }
  };

  const handleDecline = async () => {
    setDeclining(true);

    try {
      await api.updateUser(translation.translator.id, {
        $pull: {
          "workPlace.reveiwing": quote.id,
          "workPlace.ongoing_projects": quote.id,
        },
        $addToSet: {
          "workPlace.declined_projects": quote.id,
          "workPlace.decline_msg": {
            message,
            quote: quote.id,
            createdAt: new Date(),
          },
        },
      });
      await api.updateQuote(quote.id, {
        $pull: { translations: translation },
        $inc: { "tracker.translation": -1 },
      });
      await api.counter({ completed_projects: -1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          completed_projects: counter.completed_projects - 1,
        },
      });
      if (quotesLength < 2) history.push("/admin/index");
      if (quotesLength > 1) setShowVerify(false);
      dispatch({ type: REMOVE_COMPLETED_QUOTES, id: quote.id });
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    } finally {
      setDeclining(false);
    }
  };

  const handleRemove = (i) => {
    const removedFile = stampedFiles.filter((upload, index) => index !== i);
    setSize(removedFile.reduce((acc, curr) => acc + curr.size, 0));
    setStampedFiles(removedFile);
  };

  const handleChange = (e) => {
    const toBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const uploadedFiles = Array.from(e.target.files);
    const totalSize =
      uploadedFiles.reduce((acc, curr) => acc + curr.size, 0) +
      stampedFiles.reduce((acc, curr) => acc + curr.size, 0);
    const rejectedFiles = uploadedFiles.filter(
      (file) =>
        file.name.substr(file.name.lastIndexOf("."), file.name.length) !==
        ".pdf"
    );
    if (rejectedFiles.length > 0)
      return dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "Only a PDF file can be uploaded",
          duration: 7000,
          display: true,
        },
      });
    if (totalSize > 12000000)
      return dispatch({
        type: ALERT,
        payload: {
          severity: "error",
          message: "Files can not be larger than 12MB",
          duration: 7000,
          display: true,
        },
      });

    const refinedFiles = async () => {
      const fileUrl = [];
      uploadedFiles.forEach((file) => {
        fileUrl.push(toBase64(file));
      });
      const fileUrls = await Promise.all(fileUrl);
      const newFiles = fileUrls.map((base64File, index) => ({
        base64: base64File,
        size: uploadedFiles[index].size,
        name: uploadedFiles[index].name.substr(
          0,
          uploadedFiles[index].name.lastIndexOf(".")
        ),
        type: uploadedFiles[index].name.substr(
          uploadedFiles[index].name.lastIndexOf(".") + 1,
          uploadedFiles[index].name.length
        ),
      }));
      setStampedFiles([...stampedFiles, ...newFiles]);
      return newFiles;
    };

    setSize(totalSize);
    refinedFiles();
  };

  useEffect(() => {
    const getFile = async () => {
      try {
        if (completed) {
          const { data } = await api.getTranslations(quote.id);
          setTranslations(data.translations);
        } else {
          const { data } = await api.getFiles(quote.id);
          setFiles(data.files);
        }
      } catch (error) {
        if (error.response)
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: error.response.data.message,
              duration: 5000,
              display: true,
            },
          });
        else
          dispatch({
            type: ALERT,
            payload: {
              severity: "error",
              message: "An unexpected error occurred",
              duration: 5000,
              display: true,
            },
          });
      } finally {
        setLoading(false);
      }
    };
    if (showVerify && quote) getFile();
  }, [showVerify, quote, completed, dispatch]);

  const largeDocStyle = {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100vw",
    height: "100vh",
  };

  return (
    <>
      <div className="verify position-fixed t-0 r-0 overflow-auto h-100 z-3">
        {docLarge && (
          <div
            className="verify__doc__sm position-fixed l-0 t-0 m-5 rounded-50 z-5 pointer"
            onClick={() => setDocLarge(false)}
          >
            <ArrowForward />
          </div>
        )}
        <h2
          className="verify__head d-flex align-center font-subhead p-40 pointer"
          onClick={() => setShowVerify(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "45px" }} />
          {quote.projectName}
        </h2>

        <div className="verify__scroll">
          <div className="verify__min__width d-flex mx-40 py-20">
            <div className="verify__left d-flex flex-column">
              <div className="verify__top d-flex pb-40">
                <div className="pr-10 ">
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Project Name:</span>
                    <span
                      className="lh-lg font-heavy ellipsis pr-10"
                      title={quote.projectName}
                    >
                      {quote.projectName}
                    </span>
                  </div>
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Project ID:</span>
                    <span
                      className="lh-lg font-heavy text-uppercase ellipsis pr-10"
                      title={quote.quote_id}
                    >
                      {quote.quote_id}
                    </span>
                  </div>
                  {completed && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">Delivery Date:</span>
                      <span
                        className="lh-lg font-heavy"
                        title={dayjs(quote.deliveryDate).format(
                          "dddd, MMMM D YYYY"
                        )}
                      >
                        {dayjs(quote.deliveryDate).fromNow()}
                      </span>
                    </div>
                  )}
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Urgent:</span>
                    <span
                      className="lh-lg font-heavy"
                      title={quote.urgent ? "Yes" : "No"}
                    >
                      {quote.urgent ? "Yes" : "No"}
                    </span>
                  </div>
                  {!completed && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">Total pages:</span>
                      <div className="lh-lg font-heavy">
                        {isNaN(totalPages) ? "NA" : totalPages}
                      </div>
                    </div>
                  )}
                  {completed && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">
                        {quote.totalPages ? "Total Pages: " : "Total Words: "}
                      </span>
                      <div className="lh-lg font-heavy">
                        {quote.totalPages ? quote.totalPages : quote.totalCount}
                      </div>
                    </div>
                  )}
                  {!completed && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">Price per page:</span>
                      <label className="d-flex align-center lh-lg font-heavy border-bottom-1">
                        <span>$</span>
                        <input
                          className="mt-5 border-0 pl-5 py-5 outline-0 font-normal"
                          type="number"
                          placeholder="0.00"
                          onChange={(e) => setPrice(parseFloat(e.target.value))}
                        />
                      </label>
                    </div>
                  )}
                  {completed && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">Translators:</span>
                      <span className="lh-lg font-heavy text-capitalise ellipsis">
                        {translators.join(", ")}
                      </span>
                    </div>
                  )}
                </div>
                <div className="pl-10">
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Translation:</span>
                    <span
                      className="lh-lg font-heavy text-uppercase ellipsis pr-10"
                      title={`${quote.languageFrom} to ${languageTo
                        .map((lang) => lang)
                        .join(", ")}`}
                    >
                      {quote.languageFrom.substring(0, 2)}-
                      {languageTo.map((lang) => lang.substring(0, 2)).join(",")}
                    </span>
                  </div>
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Email:</span>
                    <span
                      className="lh-lg font-heavy ellipsis"
                      title={`${quote.email}`}
                    >
                      {quote.email}
                    </span>
                  </div>
                  <div className="d-flex">
                    <span className="lh-lg font-bolder">Category:</span>
                    <span
                      className="lh-lg font-heavy"
                      title={`${quote.category} package at $${checkPrice(
                        quote.category
                      )}`}
                    >
                      {quote.category}
                    </span>
                  </div>
                  {quote.translatorNote !== "" && (
                    <div className="d-flex">
                      <span className="lh-lg font-bolder">Note:</span>
                      <div
                        className="verify__note lh-lg font-heavy overflow-auto px-5"
                        title={`${quote.translatorNote}`}
                      >
                        {quote.translatorNote}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="verify__bottom pt-40">
                <div className="verify__bottom__head grid c-4 p-10 px-40 font-bolder">
                  Project Summary
                </div>
                <div>
                  {!completed && (
                    <div className="grid c-4 p-10 px-40 py-20">
                      <span className="font-bolder">File Name</span>
                      <span className="font-bolder">Document Type</span>
                      <span className="font-bolder">Pages</span>
                    </div>
                  )}
                  {loading ? (
                    <div className="fading__ctn grid c-4 p-10 px-40 py-20">
                      <span className="fade w-75"></span>
                      <span className="fade w-45"></span>
                      <span className="fade w-75"></span>
                      <span className="fade w-100"></span>
                    </div>
                  ) : (
                    <>
                      {!completed && (
                        <>
                          {files.map((file, index) => (
                            <div
                              className="grid c-4 p-1 px-40 py-10"
                              key={file.name.concat(index)}
                            >
                              <span className="ellipsis pr-10">
                                {file.name}
                              </span>
                              <span className="ellipsis pr-10">
                                {file.type}
                              </span>
                              <div className="font-heavy">
                                <input
                                  className="border-1 p-5 pl-10 w-75 outline-0 font-normal"
                                  type="number"
                                  placeholder="0"
                                  onChange={(e) =>
                                    handlePageChange(
                                      parseInt(e.target.value),
                                      index
                                    )
                                  }
                                />
                              </div>
                              <button
                                className="border-0 outline-0 font-normal font-heavy curved-20"
                                onClick={() => handlePreviewClick(index)}
                              >
                                Preview
                              </button>
                            </div>
                          ))}
                        </>
                      )}
                      {completed && (
                        <>
                          {translations.map((translation, i) => (
                            <div key={translation._id}>
                              <h3 className="verify__grey font-big mt-20 px-40 py-10">
                                {translation.language}
                              </h3>
                              <div className="grid c-4 p-10 px-40 py-20">
                                <span className="font-bolder">File Name</span>
                                <span className="font-bolder">
                                  Document Type
                                </span>
                                <span className="font-bolder">Translator</span>
                              </div>
                              {translation.files.map((file, index) => (
                                <div
                                  className="grid c-4 p-1 px-40 py-10"
                                  key={file.name.concat(index)}
                                >
                                  <span className="ellipsis pr-10 text-capitalise">
                                    {file.name}
                                  </span>
                                  <span className="ellipsis pr-10 text-uppercase">
                                    {file.type}
                                  </span>
                                  <div className="font-heavy">
                                    {translation.translator.name}
                                  </div>
                                  <button
                                    className="border-0 outline-0 font-normal font-heavy curved-20 p-5"
                                    onClick={() => handlePreviewClick(index, i)}
                                  >
                                    Preview
                                  </button>
                                </div>
                              ))}
                            </div>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="verify__right position-relative ml-20">
              <div
                style={docLarge ? largeDocStyle : {}}
                className={loading ? "fade overflow-hidden" : "overflow-hidden"}
              >
                {!loading && !completed && (
                  <iframe
                    title={title || files[0]?.name}
                    src={src || files[0]?.base64}
                    className="border-0"
                  ></iframe>
                )}
                {!loading && completed && (
                  <iframe
                    title={title || translations[0]?.files[0]?.name}
                    src={src || translations[0]?.files[0]?.base64}
                    className="border-0"
                  ></iframe>
                )}
              </div>
              <div className="text-right">
                <button
                  className="font-bold border-0 outline-0 bg-transparent p-20"
                  onClick={() => setDocLarge(true)}
                >
                  View full document
                </button>
              </div>
              {!completed && (
                <div className="py-20">
                  <div className="d-flex justify-between">
                    <span className="font-bigger font-heavy">
                      Total Amount:{" "}
                    </span>
                    <span className="font-bigger font-bolder">
                      {isNaN(totals.subtotal)
                        ? "NA"
                        : `$${totals.total.toFixed(2)}`}
                    </span>
                  </div>
                  <div className="text-right font-bold">
                    {isNaN(totals.vat)
                      ? "NA"
                      : `$${totals.vat.toFixed(2)} VAT Included`}
                  </div>
                  {!docLarge && (
                    <button
                      style={{ opacity: disableSend ? "0.6" : "" }}
                      className="verify__orange d-flex justify-center align-center w-100 mt-20 p-10 font-normal font-bold curved-20 border-0 outline-0"
                      disabled={disableSend}
                      onClick={() => openModal("send")}
                    >
                      SEND
                    </button>
                  )}
                </div>
              )}
              {completed && (
                <div className="py-20">
                  {translations.map((translation, i) => (
                    <div
                      className="pb-10 border-bottom-1"
                      key={translation._id}
                    >
                      <h3 className="font-big">{translation.language}</h3>
                      <div className="d-flex justify-between py-10">
                        <button
                          className="verify__green border-0 outline-0 w-45 p-10 font-normal font-bold rounded"
                          onClick={() => openModal("approve", translation)}
                        >
                          Approve
                        </button>
                        <button
                          className="verify__red border-0 outline-0 w-45 p-10 font-normal font-bold rounded"
                          onClick={() => openModal("decline", translation)}
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <details className="verify__details position-fixed">
        <summary className="list-none"></summary>
        <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
          <div className="d-flex flex-column align-center text-center p-20">
            {completed && (
              <h3 className="font-subhead">
                {type === "approve" ? "Approve" : "Decline"} Translation By{" "}
                {translation.translator?.name}
              </h3>
            )}
            {!completed && (
              <h3 className="font-subhead">Send Quote to {quote.email}</h3>
            )}
            {type === "decline" && (
              <div>
                <p className="font-heavy font-big py-10">
                  Input reason for declining
                </p>
                <textarea
                  className="mt-10 mb-40 w-100 border-0 outline-0 p-10 border-1 box-shadow-lg"
                  placeholder="..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            )}
            {type === "approve" && (
              <>
                {stampedFiles < 1 ? (
                  <div className="d-flex justify-center">
                    <label className="d-flex justify-center">
                      <input
                        className="position-absolute hidden"
                        type="file"
                        accept=".pdf"
                        onChange={handleChange}
                        multiple
                      />
                      <div className="verify__upload d-flex align-center justify-center outline-0 border-0 rounded p-10 my-20 font-bold font-big pointer">
                        <LibraryAddOutlined className="mr-10" />
                        UPLOAD {translation.files.length} STAMPED FILE
                        {translation.files.length > 1 ? "S" : ""}
                      </div>
                    </label>
                  </div>
                ) : (
                  <>
                    <div className="grid c-4 pt-20 pb-10">
                      <span className="font-bolder">File Name</span>
                      <span className="font-bolder">Document Type</span>
                      <span className="font-bolder">Size</span>
                    </div>
                    {stampedFiles.map((upload, index) => (
                      <div
                        className="project__uploads__row font-big grid align-center c-4 py-5"
                        key={upload.name.concat(index)}
                      >
                        <span className="text-capitalise ellipsis">
                          {upload.name}
                        </span>
                        <span className="text-uppercase">{upload.type}</span>
                        <span>
                          {upload.size < 1000
                            ? `${upload.size} B`
                            : upload.size > 999999.9
                            ? `${(upload.size / 1000000).toFixed(1)} MB`
                            : `${(upload.size / 1000).toFixed(1)} KB`}
                        </span>
                        <button
                          className="projects__remove__btn outline-0 border-0 rounded p-5 w-100 font-bold font-normal hidden"
                          onClick={() => handleRemove(index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    <label
                      style={{ width: "fit-content" }}
                      className="d-flex justify-center pt-10"
                    >
                      <input
                        className="position-absolute r-0 hidden"
                        type="file"
                        accept=".pdf"
                        onChange={handleChange}
                        multiple
                      />
                      <div className="project__upload__sm d-flex align-center justify-center outline-0 border-0 rounded p-5 font-bold pointer">
                        <LibraryAddOutlined className="mr-10" />
                        ADD FILES
                      </div>
                    </label>
                    {translation.files.length !== stampedFiles.length && (
                      <div
                        style={{ color: "crimson" }}
                        className="d-flex align-center justify-end font-bold pt-10"
                      >
                        <CancelOutlined className="mr-5" fontSize="small" />
                        Upload the exact number of document
                      </div>
                    )}
                    {size > 12000000 && (
                      <div
                        style={{ color: "crimson" }}
                        className="d-flex align-center justify-end font-bold pt-10"
                      >
                        <CancelOutlined className="mr-5" fontSize="small" />
                        Total files size can not exceed 12MB
                      </div>
                    )}
                  </>
                )}
                <p className="font-heavy font-big py-40">
                  Document translated by {translation.translator?.name} will be
                  approved for submission to the client
                </p>
              </>
            )}
            {type === "send" && (
              <p className="font-heavy font-big py-40">
                You are sending a quote of ${totals.total.toFixed(2)} will be
                sent to {quote.email} for Project {quote.projectName}
              </p>
            )}
            <div className="d-flex justify-between">
              <button
                className="verify__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                onClick={closeModal}
              >
                Cancel
              </button>
              {type === "approve" && (
                <button
                  style={{ opacity: disable || notStamped ? "0.6" : "" }}
                  className="verify__btn__accept d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleApprove}
                  disabled={disable || notStamped}
                >
                  Approve
                  {approving && <div className="spin-white ml-10"></div>}
                </button>
              )}

              {type === "decline" && (
                <button
                  style={{
                    opacity: disable || message.trim() === "" ? "0.6" : "",
                  }}
                  className="verify__btn__decline d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleDecline}
                  disabled={disable || message.trim() === ""}
                >
                  Decline
                  {declining && <div className="spin-white ml-10"></div>}
                </button>
              )}

              {type === "send" && (
                <button
                  style={{ opacity: disableSend ? "0.6" : "" }}
                  className="verify__btn__send d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={handleSend}
                  disabled={disableSend}
                >
                  Send
                  {sending && <div className="spin-white ml-10"></div>}
                </button>
              )}
            </div>
          </div>
        </div>
      </details>
    </>
  );
};

export default Verify;
